
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Clock, CheckCircle, XCircle } from "lucide-react";

interface CurrentStatusDisplayProps {
  status: string;
  isPublished: boolean;
}

export default function CurrentStatusDisplay({ 
  status, 
  isPublished 
}: CurrentStatusDisplayProps) {
  return (
    <div className="flex items-center justify-between p-3 bg-muted rounded-lg">
      <div className="flex items-center gap-2">
        {status === 'pending' && <Clock className="h-4 w-4 text-blue-500" />}
        {status === 'approved' && !isPublished && <CheckCircle className="h-4 w-4 text-green-500" />}
        {status === 'approved' && isPublished && <CheckCircle className="h-4 w-4 text-green-600" />}
        {status === 'rejected' && <XCircle className="h-4 w-4 text-red-500" />}
        <span className="font-medium">Current Status</span>
      </div>
      <Badge variant={
        isPublished ? 'default' :
        status === 'approved' ? 'default' :
        status === 'rejected' ? 'destructive' : 'outline'
      } className={isPublished ? 'bg-green-600' : ''}>
        {isPublished ? 'PUBLISHED' : status.replace('_', ' ').toUpperCase()}
      </Badge>
    </div>
  );
}
